const messages = {
  title: "Premijos daugiklis",
  bandBonusTitle: "Premija už padangą su daugikliu",
  amountLabel: "Min. padangų skaičius (*)",
  label: "Premijos daugiklis",
  desc: "Bridgestone ir Firestone padangų skaičius. Už Firestone padangas premijos eurais nėra.",
  goals: {
    loyal: "Ištikimas",
    bronze: "Bronza",
    silver: "Sidabras",
    gold: "Auksas",
    platinum: "Platina",
  },
  andMore: "ir daugiau",
  chooseTarget: "Pasirinkti",
  selectTarget: "Pasirinkite savo metinį tikslą {year}:",
  multiplication: "Premija dauginama iš <b>{factor}</b>",
  minTyres: "<b>Minimum:</b> {tyre} padangos",
};

export default {
  messages,
};
